import { useConfig } from '@occc/config';

import RetailerNetworkLocationGroupDetailsPage from './retailer-network-location-group-details-page';
import RetailerNetworkMyStoresGroupV2Page from './retailer-network-my-stores-group-v2-page';

export const RetailerNetworkLocationGroupDetailsVersionSwitch = () => {
  const { config } = useConfig();

  return config.retailerConnectRedesignV2.enabled ? (
    <RetailerNetworkMyStoresGroupV2Page />
  ) : (
    <RetailerNetworkLocationGroupDetailsPage />
  );
};
